import React from 'react'
import GroupsControls from './GroupsControls'
import GroupsFilterTags from './GroupsFilterTags'
import { Flex } from 'antd'

const GroupsHeader = () => {
    return (
        <Flex vertical gap={8} className='mb-8'>
            <GroupsControls />
            <GroupsFilterTags />
        </Flex>
    )
}

export default GroupsHeader
